import { QuestionElement, QuestionOptionType } from '../types/serialized-types';
import { BotElement } from '../types/model-types';
import { uuid } from '../utils';


@BotElement.register("question")
class Question extends BotElement {
    options: QuestionOptionType[] = [];

    static fromJSON(obj: QuestionElement): Question {
        let q = new Question(obj.type);
        q.id = obj.id || null;
        q.options = obj.options.map(o => ({...o}));
        for (let option of q.options) {
            if (option.id === undefined) {
                option.id = uuid();
            }
        }
        return q;
    }

    shouldStop(context: object) {
        return true;
    }

    optionForOptionId(optionId: string): QuestionOptionType | null {
        for (let option of this.options) {
            if (option.id === optionId) {
                return option;
            }
        }

        return null;
    }

    gotoForOptionId(optionId: string): string | null {
        let option = this.optionForOptionId(optionId);

        if (option !== null) {
            return option.goto;
        }

        return null;
    }
}


export {
    Question
}
